var _SovosDataGridToolbar;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { array, bool, number, object, oneOfType, string } from 'prop-types';
import { styled } from '@mui/material/styles';
import SovosDataGridToolbarContainer from '../SovosDataGridToolbarContainer';
import SovosDataGridToolbarColumnsButton from '../SovosDataGridToolbarColumnsButton';
import SovosDataGridToolbarDensitySelector from '../SovosDataGridToolbarDensitySelector';
import SovosDataGridToolbarFilterButton from '../SovosDataGridToolbarFilterButton';
import SovosDataGridToolbarQuickFilter from '../SovosDataGridToolbarQuickFilter';
import SovosToolbarTitle from '../../sovos-toolbar-title/SovosToolbarTitle';
import SovosIconMenu from '../../sovos-icon-menu/SovosIconMenu';
import SovosMenuItem from '../../sovos-menu-item/SovosMenuItem';
import SovosIconButton from '../../sovos-icon-button/SovosIconButton';
import SovosToolbarBulkActions from '../../sovos-toolbar-bulk-actions/SovosToolbarBulkActions';
const ToolbarActions = styled('div')({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'nowrap',
  marginInlineStart: 'auto'
});
const Toolbar = _ref => {
  var _ToolbarProps$labels, _ToolbarProps$labels2, _ToolbarProps$labels3, _ToolbarProps$labels4;
  let {
    isLoading,
    rowSelectionModel,
    ToolbarProps
  } = _ref;
  if (!ToolbarProps) {
    return undefined;
  }
  const hasMenu = bulkAction => Array.isArray(bulkAction.onClick);
  let count = 0;
  if (rowSelectionModel) {
    if (Array.isArray(rowSelectionModel)) {
      count = rowSelectionModel.length;
    } else {
      count = 1;
    }
  }
  return /*#__PURE__*/React.createElement(SovosDataGridToolbarContainer, {
    className: "sovosDataGrid__toolbar"
  }, ToolbarProps.bulkActions && /*#__PURE__*/React.createElement(SovosToolbarBulkActions, {
    count: count,
    selectedText: (_ToolbarProps$labels = ToolbarProps.labels) === null || _ToolbarProps$labels === void 0 ? void 0 : _ToolbarProps$labels.bulkActions,
    sx: {
      height: 'auto'
    }
  }, ToolbarProps.bulkActions.map(action => {
    const {
      className: actionClassName,
      icon,
      ...otherProps
    } = action;
    if (hasMenu(action)) {
      return /*#__PURE__*/React.createElement(SovosIconMenu, _extends({
        className: actionClassName,
        disabled: isLoading,
        iconElement: icon,
        key: action.tooltipText,
        toolTipText: action.tooltipText
      }, otherProps), action.onClick.map(item => /*#__PURE__*/React.createElement(SovosMenuItem, {
        key: item.text,
        onClick: () => item.onClick()
      }, item.text)));
    }
    return /*#__PURE__*/React.createElement(SovosIconButton, _extends({
      className: actionClassName,
      disabled: isLoading,
      key: action.tooltipText
    }, otherProps), icon);
  })), (ToolbarProps === null || ToolbarProps === void 0 ? void 0 : ToolbarProps.toolbarTitle) && /*#__PURE__*/React.createElement(SovosToolbarTitle, {
    key: "title",
    sx: {
      height: 'auto'
    }
  }, ToolbarProps === null || ToolbarProps === void 0 ? void 0 : ToolbarProps.toolbarTitle), ToolbarProps.quickFilters, /*#__PURE__*/React.createElement(ToolbarActions, {
    className: "sovosDataGrid__actions"
  }, ToolbarProps.showSearch && (_SovosDataGridToolbar || (_SovosDataGridToolbar = /*#__PURE__*/React.createElement(SovosDataGridToolbarQuickFilter, null))), ToolbarProps.actionIconButtons, ToolbarProps.showColumnSelector && /*#__PURE__*/React.createElement(SovosDataGridToolbarColumnsButton, {
    title: (_ToolbarProps$labels2 = ToolbarProps.labels) === null || _ToolbarProps$labels2 === void 0 ? void 0 : _ToolbarProps$labels2.columnButtonTooltip
  }), ToolbarProps.showFilters && /*#__PURE__*/React.createElement(SovosDataGridToolbarFilterButton, {
    title: (_ToolbarProps$labels3 = ToolbarProps.labels) === null || _ToolbarProps$labels3 === void 0 ? void 0 : _ToolbarProps$labels3.filterButtonTooltip
  }), ToolbarProps.showDensityToggle && /*#__PURE__*/React.createElement(SovosDataGridToolbarDensitySelector, {
    title: (_ToolbarProps$labels4 = ToolbarProps.labels) === null || _ToolbarProps$labels4 === void 0 ? void 0 : _ToolbarProps$labels4.densityTooltip
  })));
};
Toolbar.propTypes = {
  isLoading: bool,
  rowSelectionModel: oneOfType([array, string, number]),
  ToolbarProps: object
};
export default Toolbar;